import React from "react";
import { Badge, Input } from "reactstrap";
import { Company } from "./types";

interface EnvironmentBadgeProps {
    company: Company | null;
    isEditOrCreate: boolean;
    value?: number;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const EnvironmentBadge: React.FC<EnvironmentBadgeProps> = ({ 
    company, 
    isEditOrCreate, 
    value, 
    onChange 
}) => {
    return (
        <div className="mb-3">
            {isEditOrCreate ? (
                <Input 
                    type="select" 
                    id="environmentType" 
                    name="environmentType" 
                    className="form-control-sm d-inline-block w-auto" 
                    value={value} 
                    onChange={onChange}
                >
                    <option value={1}>Pruebas</option>
                    <option value={2}>Producción</option>
                </Input>
            ) : (
                <Badge 
                    color={company?.environmentType === 1 ? "warning" : "success"} 
                    className="mb-3 px-3 py-1 fs-11"
                >
                    {company?.environmentType === 1 ? "AMBIENTE DE PRUEBAS" : "AMBIENTE DE PRODUCCIÓN"}
                </Badge>
            )}
        </div>
    );
};

export default EnvironmentBadge;
